// Router
//import { lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Auth
//import { PrivateRoutes } from '@/auth/PrivateRoutes';

// Pages
import Splash from '@/pages/splash/Splash';
import Projects from '@/pages/projects/Projects';
import Books from '@/pages/books/Books';
import Career from '@/pages/career/Career';

// Styles
import '@mantine/core/styles.css';

// Components
import RootLayout from './RootLayout';

export default function App() {
    return (
        <Routes>
            <Route path='*' element={<RootLayout />}>
                <Route path='' element={<Navigate to='/home' replace />} />
                <Route path='home' element={<Splash />} />
                <Route path='career' element={<Career />} />
                <Route path='projects' element={<Projects />} />
                <Route path='mountains' element={<div>mountains</div>} />
                <Route path='books' element={<Books />} />
                <Route path='*' element={<Navigate to='/home' replace />} />
            </Route>
        </Routes>
    );
}
